import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import RecommendationsResultsResultsDetails from 'tio-employee/components/recommendations/results/results-details';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: RecommendationModel;
  };
}

const tmpl: TOC<S> = <template>
  <TioPageBreadcrumbs class="mb-4" as |b|>
    <b.crumb @route="authenticated.pslf.dashboard.index" @label="Dashboard" />
    <b.crumb
      @route="authenticated.pslf.dashboard.forgiveness-estimator.index"
      @label="Forgiveness Estimator"
    />
    <b.crumb @route="authenticated.pslf.dashboard.forgiveness-estimator.results" @label="Results" />
  </TioPageBreadcrumbs>
  <RecommendationsResultsResultsDetails @recommendation={{@model}} @programType="pslf" />
</template>;

export default tmpl;
